"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_IDS = void 0;
var MODAL_IDS;
(function (MODAL_IDS) {
    MODAL_IDS["NONE"] = "NONE";
    MODAL_IDS["ERROR"] = "ERROR";
    MODAL_IDS["MANAGE_USERS_ADD_USER"] = "MANAGE_USERS_ADD_USER";
    MODAL_IDS["FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED"] = "FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED";
    MODAL_IDS["FAULTS_SPECIAL_INSTRUCTIONS"] = "FAULTS_SPECIAL_INSTRUCTIONS";
    MODAL_IDS["COMMENTS_SHARE"] = "COMMENTS_SHARE";
    MODAL_IDS["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
    MODAL_IDS["MAINTENANCE_SYSTEM"] = "MAINTENANCE_SYSTEM";
    MODAL_IDS["MANAGE_SCORE_CARD"] = "MANAGE_SCORE_CARD";
    MODAL_IDS["SETTINGS_REGISTRATION"] = "SETTINGS_REGISTRATION";
    MODAL_IDS["UPLOAD_DATA_MODAL"] = "UPLOAD_DATA_MODAL";
    MODAL_IDS["UPLOAD_CUSTOM_TAGS_MODAL"] = "UPLOAD_CUSTOM_TAGS_MODAL";
    MODAL_IDS["SEARCH_VEHICLES_RESULT_MODAL"] = "SEARCH_VEHICLES_RESULT_MODAL";
    MODAL_IDS["VEHICLE_CONTACT_REMOVE_MODAL"] = "VEHICLE_CONTACT_REMOVE_MODAL";
    MODAL_IDS["VEHICLE_CONTACT_LEAVE_CONFIRM_MODAL"] = "VEHICLE_CONTACT_LEAVE_CONFIRM_MODAL";
    MODAL_IDS["CUSTOMER_SUPPORT_MODAL"] = "CUSTOMER_SUPPORT_MODAL";
    MODAL_IDS["LOCK_UNLOCK"] = "LOCK_UNLOCK";
    MODAL_IDS["ADD_DEPARTURE_PROFILE_MODAL"] = "ADD_DEPARTURE_PROFILE_MODAL";
    MODAL_IDS["SUBSCRIPTIONS_REMOVE_MODAL"] = "SUBSCRIPTIONS_REMOVE_MODAL";
})(MODAL_IDS = exports.MODAL_IDS || (exports.MODAL_IDS = {}));
exports.default = MODAL_IDS;
